import { render, staticRenderFns } from "./vue-suggestion.vue?vue&type=template&id=64be6dae&"
import script from "./vue-suggestion.vue?vue&type=script&lang=js&"
export * from "./vue-suggestion.vue?vue&type=script&lang=js&"
import style0 from "./vue-suggestion.vue?vue&type=style&index=0&id=64be6dae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports